import {all, fork, put, takeLatest} from 'redux-saga/effects';
import EstService from '../../services/EstService';
import {GET_LAST_INVOICES, GET_OVERVIEW} from '../constants/Dashboards';
import moment from 'moment';
import {getLastInvoicesSuccess, getOverviewSuccess,} from '../actions/Dashboards';
import {setLoadingInvisible} from 'redux/actions';

export function* getOverview() {
  yield takeLatest(GET_OVERVIEW, function* () {
    try {
      const res = yield EstService.getOverviewDashboard();

      if (!res) {
        return;
      }

      const overview = {};
      const date_keys = Object.keys(res.data.paid_invoice_totals.days);
      const date_values = Object.values(res.data.paid_invoice_totals.days);
      const from = moment(date_keys[0], 'YYYY-MM-DD').format('MMM Do');
      const to = moment(date_keys[date_keys.length - 1], 'YYYY-MM-DD').format(
        'MMM Do'
      );

      overview.weekly_revenue = {
        date_range: `${from} - ${to}`,
        this_week: `$${res.data.paid_invoice_totals.totals.this_week.toFixed(
          2
        )}`,
        delta: res.data.paid_invoice_totals.totals.delta.toFixed(0),
      };

      const dates = [];
      date_keys.forEach((element) => {
        dates.push(moment(element, 'YYYY-MM-DD').format('Do'));
      });

      overview.weekly_revenue.categories = dates;
      overview.weekly_revenue.series = [
        {
          name: '',
          data: date_values,
        },
      ];

      overview.stats = {
        conversion_rate:
          res.data.converted_invoice_totals.totals.conversion_rate,
        last_30: res.data.paid_invoice_year_totals.totals.last_30_days,
        last_365: res.data.paid_invoice_year_totals.totals.last_365_days,
        total_customers: res.data.customer_totals.total_customers,
      };

      let fillerArray = [
        'Ford,Mustang',
        'Chevy,Camaro',
        'Dodge,Challenger',
        'Toyota,Supra',
        'Honda,Accord',
      ];

      let totalKeys;

      const ranges = ['year_totals', 'month_totals', 'week_totals'];
      ranges.forEach((element) => {
        totalKeys = Object.keys(res.data.top_manufacturers[element]).length;
        for (let i = 0; i < 5 - totalKeys; i++) {
          res.data.top_manufacturers[element][fillerArray[i]] = 0;
        }
      });
      overview.top_manufacturers = res.data.top_manufacturers;

      fillerArray = [
        'Engine Repair',
        'Brakes',
        'Transmission',
        'Cooling System',
        'Electrical Systems',
      ];

      ranges.forEach((element) => {
        totalKeys = Object.keys(res.data.sales_categories_data[element]).length;
        for (let i = 0; i < 5 - totalKeys; i++) {
          res.data.sales_categories_data[element][fillerArray[i]] = 0;
        }
      });
      overview.sales = res.data.sales_categories_data;

      overview.customers = res.data.customer_totals;

      yield put(getOverviewSuccess(overview));
    } catch (err) {
      console.log(err);
    }
  });
}

// To obtain the last N invoices, we need to obtain the number of elements first.
export function* getLastInvoices() {
  yield takeLatest(GET_LAST_INVOICES, function* ({ per_page }) {
    try {
      const perPage = per_page;
      const res = yield EstService.getInvoices(perPage, 1);

      if (!res) {
        return;
      }

      yield put(getLastInvoicesSuccess(res.data.data));
    } catch (err) {
      console.log(err);
    } finally {
      yield put(setLoadingInvisible());
    }
  });
}

export default function* dashboardsSaga() {
  yield all([fork(getOverview), fork(getLastInvoices)]);
}
